import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    Router,
    NavigationEnd,
    ActivatedRoute,
    ActivatedRouteSnapshot,
    NavigationStart,
    RouterStateSnapshot
} from '@angular/router';
import 'rxjs/add/operator/filter';
import { RoutePartsService } from './shared/services/route-parts.service';
import { ThemeService } from './shared/services/theme.service';
import { environment } from '../environments/environment';
import {
    InternalStorage,
    LoopBackConfig,
    CompanyAccountApi,
    RoleApi, UserProfileApi
} from './shared/services/sdk/index';
import { NgxPermissionsService } from 'ngx-permissions';
import { current } from '../../node_modules/codelyzer/util/syntaxKind';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
    appTitle = 'JIJIRENTALS | Property Management System';
    pageTitle = '';
    protected prefix: String = '$LoopBackSDK$';
    snapshot: RouterStateSnapshot;

    constructor(
        public title: Title,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private routePartsService: RoutePartsService,
        private themeService: ThemeService,
        private renderer: Renderer2,
        private permissionsService: NgxPermissionsService,
        private storage: InternalStorage,
        private userProfileApi: UserProfileApi,
        private companyAccountApi: CompanyAccountApi,

    ) {
        LoopBackConfig.setBaseURL(environment.apiURL);
        LoopBackConfig.setApiVersion('api');
         this.snapshot = router.routerState.snapshot;
    }

    ngOnInit() {
        this.setTheme();
        this.changePageTitle();
        if (this.storage.get(`${this.prefix}userRole`)) {
            const roles = this.storage.get(`${this.prefix}userRole`).split(',');
            this.permissionsService.loadPermissions(roles);
        }
    }

    setTheme() {
        this.companyAccountApi.getHostAccount().subscribe(data => {
            this.appTitle = data.property_name;
            localStorage.setItem('host_configs', JSON.stringify(data));
            this.setFavicon(data && data.settings && data.settings.favicon);
            if ( data && data.settings && data.settings.theme) {
               localStorage.setItem(
                'currentTheme',
                JSON.stringify({
                    token: 'current theme',
                    name: data.settings.theme
                })
            ); 
            }else{
                localStorage.setItem(
                'currentTheme',
                JSON.stringify({
                    token: 'current theme',
                    name: "hopetrust"
                }))
            }
            
            // this.themeService.setThemeFromQuery();
            // this.themeService.changeTheme(this.renderer, data.settings.theme);
        });
    }

    // Swaps the <link id="app-favicon"> href to this instance's configured
    // favicon (a data URL saved on the company account settings). Falls back
    // to the static favicon.ico already in index.html when none is set.
    setFavicon(faviconDataUrl: string) {
        if (!faviconDataUrl) { return; }
        const link = document.getElementById('app-favicon') as HTMLLinkElement;
        if (link) { link.href = faviconDataUrl; }
    }

    checkLogin() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationStart)
        ).subscribe((event: NavigationStart) => {
            // console.log(event.url, this.snapshot);
            if (event instanceof NavigationStart && this.userProfileApi.isAuthenticated()) {
                this.router.navigate(['/sessions/signin'], {queryParams: { returnUrl: this.snapshot.url } } );
            }

        });

    }

    ngAfterViewInit() {
        this.themeService.applyMatTheme(this.renderer);
    }

    changePageTitle() {
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(routeChange => {
                var routeParts = this.routePartsService.generateRouteParts(
                    this.activeRoute.snapshot
                );
                if (!routeParts.length)
                    return this.title.setTitle(this.appTitle);
                // Extract title from parts;
                this.pageTitle = routeParts
                    .reverse()
                    .map(part => part.title)
                    .reduce((partA, partI) => {
                        return `${partA} > ${partI}`;
                    });
                this.pageTitle += ` | ${this.appTitle}`;
                this.title.setTitle(this.pageTitle);
            });
    }

    getRoles() {}
}
